"use strict";

exports.__esModule = true;
exports.guessRelativeTextSize = void 0;
/**
 * Guess the relative text size of the given input string.
 * This is not very accurate but it is very fast.
 */
var guessRelativeTextSize = exports.guessRelativeTextSize = function guessRelativeTextSize(input) {
  var size = 0;
  for (var i = 0; i < input.length; i++) {
    var _char = input.charCodeAt(i);
    if (_char < 32) {} else if (!charCodeToSize[_char] && _char >= 97 && _char <= 122) {
      // lowercase letters without special cases
      size += 0.8;
    } else if (charCodeToSize[_char] !== undefined) {
      // special characters and special cases
      size += charCodeToSize[_char];
    } else {
      size += 1;
    }
  }
  return size;
};

// special characters and special cases
var charCodeToSize = {
  33: 0.4,
  // !
  34: 0.4,
  // "
  39: 0.4,
  // '
  40: 0.4,
  // (
  41: 0.4,
  // )
  44: 0.4,
  // ,
  45: 0.4,
  // -
  46: 0.4,
  // .
  58: 0.4,
  // :
  59: 0.4,
  // ;
  91: 0.4,
  // [
  93: 0.4,
  // ]
  123: 0.4,
  // {
  125: 0.4,
  // }
  73: 0.6,
  // I
  49: 0.4,
  // 1
  105: 0.4,
  // i
  108: 0.4 // l
};